<div *ngIf="isImageLoading">
  <img class="{{class}}"
    width="100%"
    height="100%"
    [alt]="alt"
    src="assets/image/preloader.gif">
</div>
<img [src]="src"
  width="100%"
  height="100%"
  class="{{class}}"
  [alt]="alt"
  [ngClass]="{'img-display-none':isImageLoading}"
  (load)="onImageLoadSuccess()"
  (error)="onImageLoadFailure()">
